export const REQUEST_VERIFY_OTP = 'REQUEST_VERIFY_OTP';
export const VERIFY_OTP_RECIEVED= 'VERIFY_OTP_RECIEVED';
